<template>
  <div id="hrms75e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :unLoadBool="true"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHrms75eIndex"
            :deleteInlineEventBool="true"
            :saveInlineEvent="deleteEvent"
            :columnEvent="columnEvent"
            :addEvent="addEvent"
            :editEvent="editEvent"
            searchBoxAlias="hrms75e"
            :saveBtnSearchBoxTable="true"
            :callSearchEvent="callSearchEvent" />

    <detail v-show="detailDisp"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :searchIndex="searchIndex"
            :searchDetailCours="searchDetailCours"
            :receivedHrms75eDetail="receivedHrms75eDetail"
            :detail="detail"
            :toggle="toggle"
            :eventBtn="eventBtn"
            :indexSelected="indexSelected"
            :nowLang="app.nowLang"
            :lovCurrentDesc="lovCurrentDesc"
            :detailCoursColumns="columns[app.nowLang].detailCours"
            :postHrms75eDetailCoursSave="postHrms75eDetailCoursSave"
            :detailTab1Columns="columns[app.nowLang].detailTab1"
            :postHrms75eTab1Save="postHrms75eTab1Save"
            :detailTab2Columns="columns[app.nowLang].detailTab2"
            :detailTab2Popup="detailTab2Popup"
            :detailTab2PopupColumns="columns[app.nowLang].detailTab2Popup"
            :receivedHrms75eDetailTab2Popup="receivedHrms75eDetailTab2Popup"
            :detailTab3Columns="columns[app.nowLang].detailTab3"
            :detailTab3MaxRowspan="maxRowspan.detailTab3"
            :detailTab4Columns="columns[app.nowLang].detailTab4"
            :detailTab4Popup="detailTab4Popup"
            :detailTab4PopupColumns="columns[app.nowLang].detailTab4Popup"
            :receivedHrms75eDetailTab4Popup="receivedHrms75eDetailTab4Popup"
            :detailTab5Columns="columns[app.nowLang].detailTab5"
            :detailTab5MaxRowspan="maxRowspan.detailTab5"
            :codempid="codempid"
            :descCodempid="app.currentUser.username[app.nowLang]"
            :setAddCodcours="setAddCodcours"  />
    <input data-toggle="modal" data-target="#hrms75e-popup-cours" ref="popupCours" type="hidden"/>

    <popup-cours :labels="labels[app.nowLang]"
                 :nowLang="app.nowLang"
                 :data="popupCours"
                 :indexSelected="indexSelected" />
  </div>
  
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms75e/mutation-types'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import detail from 'components/hrms75e/detail'
import swal from 'sweetalert'
import popupCours from 'components/hrms75e/popupCours'
import moment from 'moment'

export default {
  name: 'hrms75e',
  data () {
    return {
      searchIndex: {
        year: moment().format('YYYY')
      },
      searchDetailCours: {
        codempid: '',
        year: ''
      },
      eventBtn: '',
      app: this.$root.$children[0]
    }
  },
  created () {
    this.receivedHrms75eColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS75E_INDEX_DISP,
      detailDisp: types.GET_HRMS75E_DETAIL_DISP,
      labels: types.GET_HRMS75E_LABELS,
      index: types.GET_HRMS75E_INDEX,
      columns: types.GET_HRMS75E_COLUMNS,
      indexSelected: types.GET_HRMS75E_INDEX_SELECTED,
      detail: types.GET_HRMS75E_DETAIL,
      maxRowspan: types.GET_HRMS75E_MAX_ROWSPAN,
      popupCours: types.GET_HRMS75E_COURS_POPUP,
      detailTab2Popup: types.GET_HRMS75E_DETAIL_TAB2_POPUP,
      detailTab4Popup: types.GET_HRMS75E_DETAIL_TAB4_POPUP,
      searchParamsIndex: types.GET_HRMS75E_SEARCH_PARAMS_INDEX,
      lovCurrentDesc: lovTypes.GET_LOV_CURRENT_DESC
    })
  },
  methods: {
    pageDetail (event, param) {
      this.eventBtn = event
      switch (event) {
        case 'add':
          this.searchDetailCours.year = moment().year()
          this.searchDetailCours.codempid = ''
          this.receivedHrms75eDetailCreate()
          this.toggle('detail')
          break
        case 'edit':
          let detailParams = {
            p_dteyear: this.searchIndex.year,
            p_codempid_query: param.codempid
          }
          this.setIndexSelected(param)
          this.searchDetailCours.year = this.searchIndex.year
          this.searchDetailCours.codempid = param.codempid
          this.receivedHrms75eDetail(detailParams)
          this.toggle('detail')
          break
      }
    },
    addEvent () {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.pageDetail('edit', param)
    },
    callSave (dataRowsHasFlg) {
      if (dataRowsHasFlg.length > 0) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.postHrms75eDetailCoursSave({ dataRowsHasFlg: dataRowsHasFlg, searchIndex: this.searchIndex, searchDetailCours: { codempid: this.searchIndex.codempid, year: this.searchIndex.year } })
          }
        })
      }
    },
    deleteEvent (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHrms75eIndexCancel({ dataRowsHasFlg: dataRowsHasFlg, searchIndex: this.searchIndex })
        }
      })
    },
    columnEvent (eventName, param) {
      switch (eventName) {
        case 'codempid':
          if (param.codempid !== '') {
            let valid = true
            for (var i = 0; i < this.index.rows.length - 1; i++) {
              if (this.index.rows[i].codempid === param.codempid) {
                valid = false
              }
            }
            if (valid) {
              this.receivedHrms75eIndexAddInline(param)
            } else {
              swal({
                title: 'ยืนยันการทำรายการ',
                text: 'รายการนี้ได้ถูกเลือกไปแล้ว'
              })
            }
          }
          break
        case 'cours':
          let popupParams = {
            p_codcours: param.codcours
          }
          this.setIndexSelected(param)
          this.receivedHrms75eCoursPopup(popupParams)
          this.$refs.popupCours.click()
          break
      }
    },
    callSearchEvent () {
      if (this.searchIndex.codempid !== '') {
        this.searchIndex.codcomp2 = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS75E_INDEX_SELECTED,
      setAddCodcours: types.SET_HRMS75E_ADD_CODCOURS
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS75E_PAGE,
      receivedHrms75eColumnsLabels: types.RECEIVED_HRMS75E_COLUMNS_LABELS,
      receivedHrms75eIndex: types.RECEIVED_HRMS75E_INDEX,
      postHrms75eDetailCoursSave: types.POST_HRMS75E_DETAIL_COURS_SAVE,
      postHrms75eTab1Save: types.POST_HRMS75E_TAB1_SAVE,
      postHrms75eTab4Save: types.POST_HRMS75E_TAB4_SAVE,
      postHrms75eIndexCancel: types.POST_HRMS75E_INDEX_CANCEL,
      receivedHrms75eDetailCreate: types.RECEIVED_HRMS75E_DETAIL_CREATE,
      receivedHrms75eDetail: types.RECEIVED_HRMS75E_DETAIL,
      receivedHrms75eCoursPopup: types.RECEIVED_HRMS75E_COURS_POPUP,
      receivedHrms75eIndexAddInline: types.RECEIVED_HRMS75E_INDEX_ADD_INLINE,
      receivedHrms75eDetailTab2Popup: types.RECEIVED_HRMS75E_DETAIL_TAB2_POPUP,
      receivedHrms75eDetailTab4Popup: types.RECEIVED_HRMS75E_DETAIL_TAB4_POPUP
    })
  },
  components: {
    detail,
    popupCours
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?cf1e7cfa